// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1nszb","fileBtn":"File_fileBtn__2MGAT","closeBtn":"File_closeBtn__30Dn8","fileSelected":"File_fileSelected__1D7hv","disabled":"File_disabled__2XTUc"};